import { createUseStyles } from '@glu/theming';

const styles = ({
  backgrounds: { default: white },
  palette: {
    common: { black },
    grey: { G400 }
  },
  spacing: { unit },
  zIndex: { drawer }
}) => ({
  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: white,
    border: `1px solid ${G400}`,
    minWidth: unit * 20,
    padding: unit * 1.25,
    position: 'absolute',
    right: 0,
    top: unit * 3,
    zIndex: drawer
  },
  menuButton: {
    color: black,
    border: 'none',
    background: 'none',
    display: 'inline-block',
    padding: [4, 6, 4, 10],
    '&:hover': {
      textDecoration: 'none'
    }
  }
});

export default createUseStyles(styles);
